import React, { FC, useState } from 'react'
import Link from 'next/link'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules'
import { event } from '@/pages/api/gtag'
import 'swiper/css'
import 'swiper/css/pagination'

import EditProfilePopup from '@/components/molecules/MyMenu/EditProfilePopup'

interface MenuSwiperProps {
  profile: any
}

// イベントごとに更新する
const RANKING_EVENT = {
  entry_url: 'https://fanme.link/ranking/event/fanme-league-202504-f2/info?page=creator',
  media_url: 'https://media.fanme.link/1646/',
  entry_start_at: '2025-04-07 18:00',
  end_at: '2025-04-25 23:59',
  image_path: '/menu/ranking-event-202504.webp',
}

const CarouselLinks: FC<MenuSwiperProps> = ({ profile }) => {
  const [editProfilePopupVisible, setEditProfilePopupVisible] = useState(false)

  function isInDateRange(startDate: string, endDate: string): boolean {
    const now = new Date()
    const start = new Date(startDate)
    const end = new Date(endDate)
    return now >= start && now <= end
  }

  function rankingEventBannerOnClick() {
    event({
      action: 'fanme_ranking_event_banner_click',
      category: 'fanme_ranking_event',
      label: 'fanme_ranking_event_banner_click',
      value: 'fanme_ranking_event_banner_click',
    })
    window.open(RANKING_EVENT.entry_url, '_blank')
  }

  return (
    <>
      {(profile?.birthday === '1900-01-01' ||
        isInDateRange(RANKING_EVENT.entry_start_at, RANKING_EVENT.end_at)) && (
        <Swiper
          cssMode={true}
          slidesPerView={'auto'}
          centeredSlides={true}
          pagination={{
            enabled: true,
            clickable: true,
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination]}
          className="fanme-swiper-black max-w-[338px] h-[116px]"
        >
          {profile?.birthday === '1900-01-01' && (
            <SwiperSlide key={`menu_0`} className="pt-4">
              <img
                src={'/menu/birthday-setting.webp'}
                onClick={() => setEditProfilePopupVisible(true)}
                width={388}
                height={80}
                className={'object-cover rounded-2xl cursor-pointer'}
              />
            </SwiperSlide>
          )}
          {isInDateRange(RANKING_EVENT.entry_start_at, RANKING_EVENT.end_at) && (
            <SwiperSlide key={`menu_1`} className="pt-4">
              <img
                src={RANKING_EVENT.image_path}
                alt="ranking_event"
                width={388}
                height={80}
                className="object-cover rounded-2xl cursor-pointer"
                onClick={() => rankingEventBannerOnClick()}
              />
            </SwiperSlide>
          )}
        </Swiper>
      )}
      {isInDateRange(RANKING_EVENT.entry_start_at, RANKING_EVENT.end_at) && (
        <Link
          href={RANKING_EVENT.media_url}
          target="_blank"
          className="text-center text-[#00B9E6] text-sm mt-2 underline"
        >
          イベント参加のメリット
        </Link>
      )}
      <EditProfilePopup
        visible={editProfilePopupVisible}
        onClose={() => setEditProfilePopupVisible(false)}
      />
    </>
  )
}

export default CarouselLinks
